"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userWorkspaceSettingsDataLoaderFactory = void 0;
var DataLoaderAbstractFactory_1 = require("./DataLoaderAbstractFactory");
var UserWorkspaceSettingsDataLoader = /** @class */ (function () {
    function UserWorkspaceSettingsDataLoader(workspace) {
        this.workspace = workspace;
    }
    UserWorkspaceSettingsDataLoader.prototype.getUserWorkspaceSettings = function (backend) {
        var _this = this;
        if (!this.cachedUserWorkspaceSettings) {
            this.cachedUserWorkspaceSettings = backend
                .workspace(this.workspace)
                .settings()
                .getSettingsForCurrentUser()
                .catch(function (error) {
                _this.cachedUserWorkspaceSettings = undefined;
                throw error;
            });
        }
        return this.cachedUserWorkspaceSettings;
    };
    return UserWorkspaceSettingsDataLoader;
}());
/**
 * @internal
 */
exports.userWorkspaceSettingsDataLoaderFactory = DataLoaderAbstractFactory_1.dataLoaderAbstractFactory(function (workspace) { return new UserWorkspaceSettingsDataLoader(workspace); });
//# sourceMappingURL=UserWorkspaceSettingsDataLoader.js.map